import { Injectable } from '@angular/core'

interface Styles {
  [key: string]: string
}

@Injectable({ providedIn: 'root' })
export class SeDialogHelper {

  win: Window = window
  body: HTMLElement = document.body
  scrollY: number
  oldStyles: Styles
  disabled: boolean = false

  public disableScroll(): void {
    if (this.disabled) return
    this.disabled = true

    const { paddingRight, position, top, width } = this.body.style
    const padding = (parseInt(paddingRight, 10) || 0) + this.scrollbarWidth
    const scrollY = this.scrollY = this.win.scrollY

    this.oldStyles = { paddingRight, position, top, width }
    this.applyStyles({
      paddingRight: `${padding}px`,
      position: 'fixed',
      top: `-${scrollY}px`,
      width: `${this.body.offsetWidth}px`,
    })
  }

  public enableScroll(): void {
    if (!this.disabled) return
    this.disabled = false

    this.win.scrollTo(0, this.scrollY)
    this.applyStyles(this.oldStyles)
  }

  private applyStyles(styles: Styles): void {
    for (const prop in styles) {
      this.body.style[prop] = styles[prop]
    }
  }

  // This only works when the page is already scrolling, which happens to be when we need to use it \o/
  private get scrollbarWidth(): number {
    return this.win.innerWidth - this.body.offsetWidth
  }
}
